import { render, staticRenderFns } from "./OntimeVsLate.vue?vue&type=template&id=1b4b30e6"
import script from "./OntimeVsLate.vue?vue&type=script&lang=js"
export * from "./OntimeVsLate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports